export default __webpack_public_path__ + "static/metabolism-box@2x-8d96f6de1a997f4c9dfbbb3cb69d973f.png";